<style>
	.bg343 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar5{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar5 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar5 span.pos{  padding:0 1vw;}
.tabbar5 span.floder{ color:#666;}
 
.tabbar5 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}



.steps{width:84vw;height:6vw;margin:0;padding:0;overflow:hidden; 
border-bottom:#f3f7f8 solid 1px;margin-top:7vw;position:relative;margin-left:7vw;
 }
.steps ul{width:65vw;height:3.5vw; float:left;box-sizing:border-box;box-sizing:border-box;position:absolute;top:0;cursor:pointer;}
.steps ul li{float:left;padding: 0 1vw;height:3.5vw;line-height:3.5vw;font-size:1.4vw;box-sizing:border-box;text-align:center;}
.steps ul li.on{border-bottom:#3268ff solid 0.15vw;color:#3268ff; }
.steps ul li:hover{background:#f1f1f1; }
  
.submitss{width:12vw;height:4vw;background:#3268ff;margin-top:1vw;border-radius:.5vw;}
.submitss span{display:block;float:left;width:6vw;text-align:center;color:#fff;font-size:1.4vw;line-height:4vw;cursor:pointer;}
.submitss img{display:block;float:left;width:2vw;margin-top:1vw;height:2vw;margin-left:1.5vw;}
.submitss:hover{background:#4C84FA;}



.template_div{margin:0;padding:0;overflow:hidden;width:84vw; margin-left:7vw;border:#f1f1f1 solid 1px;border-radius:.5vw;margin-top:0;}
.c_head{margin:0;padding:0;overflow:hidden;width:100%;background:#f6f6f6;height:4vw;}
.c_head span.c1{display:block;width:12vw;line-height:4vw;font-size:1.4vw;text-align:center;float:left;font-weight:bold;}
.c_head span.c2{display:block;line-height:4vw;font-size:1.1vw;text-align:center;float:right;color:#ffad57;padding:0 .5vw;}
.tanh{width:1.6vw;height:1.6vw;border-radius:1.6vw;background:#ffad57;float:right;margin-top:1.2vw;}
.tanh img{display:block;margin:0 auto;width:1.1vw;margin-top:.25vw;}

.code_area{margin:0;padding:0;overflow:hidden;width:100%;border-bottom:#f1f1f1 solid 1px;padding-bottom: 1vw;}
.code_area ul li{width:10.9vw;float:left;border:#f1f1f1 solid 1px;box-sizing:border-box;margin-left:1vw;height:3vw;margin-top:1vw;
      border-radius:.5vw;cursor:pointer;}
.code_area ul li span{display:block;float:left;line-height:3vw;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}
.code_area ul li span.ca1{color:#000;font-size:1vw;padding-left:.5vw;}
.code_area ul li span.ca2{color:#3465ff;font-size:1vw;padding-left:.5vw;}
.code_area ul li:hover{background:#eee;}

.template_content{width:100%;height:10vw;}
.template_content textarea{width:94%;padding:1vw 3%;height:8vw;border:0;outline:none;font-size:1.2vw;line-height:2vw;}
textarea::placeholder{font-size:1.2vw;font-family:"黑体";color:#bbb;}
.check{width:70vw;background:#f6f6f6;height:4vw;margin-left: 14vw;}
.check span{display:block;float:left;text-align:left;font-size:1.2vw;line-height:4vw;padding-left:1vw;}
.check button{display:block;float:right;border:0;outline:none;background:#3268ff;height:4vw;color:#fff;padding:0 2vw;font-size:1.3vw;}
.check button:hover{background:#4C84FA;}

.select_mb{left: 0;bottom: 0;position: absolute;width: 14vw;cursor: pointer;}
.select_mb span{display: block;width: 13vw;text-align: center;line-height: 4vw;font-size: 1.4vw;color: #fff;background: #ffad57;
height: 4vw;padding: 0 .5vw;bottom: 0;position: absolute;z-index: 99999;}
.select_mb ul{width:14vw;list-style: none;bottom: 4vw;position: absolute;border-radius:1vw;z-index: 9999;}
.select_mb ul li{width: 13vw;padding: 0 .5vw;background: #507bf1;height: 3vw;text-align: left;line-height: 3vw;color: #fff;border-bottom: #eee solid 1px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;font-size: 1.2vw;}
.select_mb ul li:hover{background: #3268ff;cursor: pointer;}


.new_template2{width:12vw;float:right;height:3vw;border:#4471ff solid 1px;margin-top:.5vw;border-radius:.5vw;cursor:pointer;}
.new_template2 img{width:2vw;margin-top:.5vw;margin-left:.5vw;display:block;float:left;margin-left:1vw;}
.new_template2 span{display:block;float:left; text-align:center;line-height:3vw;font-size:1.2vw; 
  color:#4471ff;margin-left:.6vw;}
  
  
.new_template2:hover{background:#4471ff; }
.new_template2 span:hover{color:#fff;}
  
</style>
<template>
	<div class="bg343">
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="home()" src="../../assets/images/home_icon.png">
			<div class="tabbar5">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">短信模板</span>
			   <span class="rights"></span>
			   <span class="floder">编辑短信模板</span>
			</div>
		 </div>
		 <div class="steps">
		      <ul>
			     <li :class="item.class" v-for="item in steps" @click="step(item.id)">{{item.name}}</li> 
			  </ul>
		 </div>
		 <div class="template_div" style="position: relative;">
		    <div class="c_head">
			   <span class="c1">编辑短信模板</span>
			   <span class="c2">模板不支持连续组合变量</span>
			   <div class="tanh">
			      <img src="../../assets/images/tan.svg">
			   </div>
			</div>
		    <div class="code_area">
			   <ul>
			     <li v-for="item in list" @click="insertAtCursor(item.value)"><span class="ca1">{{item.name}}</span><span class="ca2">{ {{item.value}} }</span></li>
			   </ul>
			</div>
		    <div class="template_content">
			   <textarea id="textarea"  placeholder="请输入短信模板内容" maxlength="300" ref="count" v-model="content" ></textarea>
			</div>
			<div class="select_mb">
				<span class="qianming" @click="sign()" v-if="!sign_selected">选择签名</span>
				<span class="qianming" @click="sign()" style="font-size: 1.2vw"  v-else>{{signname}}</span>
				   <transition name="draw2">
				      <ul v-show="sign_show">
				      	<li v-for="item in sign_list" @click="choose_sign(item.name)">{{item.name}}</li>
				      </ul>
				 </transition>
			</div>
			<div class="check">
			   <span>{{current_length}}/300</span>
                  <span>预计短信计费条数{{count}}条（每67个字符为一条计费短信）</span>
			   <button @click="edit_template()">提交审核</button>
			   <button style="background: #ffad57;" @click="template_view()">短信预览</button>
			</div>
		 
		 </div>
		  
		 <div class="submitss" @click="back()">
		      <img src="../../assets/images/pre.svg">
		     <span>返回</span>
			 
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
	export default {
	    components: {
		  u_center,
	    },
		data() {
			return {
				steps:[],
				list:[],
				token:"",
				content:"",
				current_length:0,
				type:"",
				sms_code:"https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code.png",
				id:"",
				count:0,
				sign_show:false,
				sign_selected:false,
				signname:"选择签名",
				sign_list:[{id:1,name:"西财天府"},{id:2,name:"西财天府考试院"},{id:3,name:"西财天府艺术学院"}]
			}
		},
		mounted() {
		      this.id = this.$utils.getUrlKey('id');	
		      let self=this;
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_sms_type();
				  self.get_template_value();
				  self.get_template_content();
				  self.get_sign_list();
				  self.get_template_sign();
			  } 
		},
		methods: {
		  sign(){
              this.sign_show=!this.sign_show;
			},
		  choose_sign(name){
              this.signname=name
              this.sign_show=false
              this.sign_selected=true
		   },
		    mouseOver_sms() {
			   this.sms_code="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code2.png";
		   },mouseLeave_sms() {
		       this.sms_code="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code.png";
		   },
		   async insertAtCursor(myValue) {
		        myValue='{'+myValue+'}'
				const myField = document.querySelector('#textarea')
				if (myField.selectionStart || myField.selectionStart === 0) {
					var startPos = myField.selectionStart
					var endPos = myField.selectionEnd
					this.content = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
					await this.$nextTick() // 这句是重点, 圈起来
					myField.focus()
					myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
				} else {
					this.content += myValue
				}
		   },
		    back(){
		        this.$router.go(-1)
		   },
		   home(){
		     this.$router.push("/");  
		   },template_view(){
                this.$router.push("/templete_view?template_id="+this.id);  
		   },
		   get_sms_type(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sms_type', {
					   token:self.token,
					   id:self.id
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.steps=data.data;	

                          self.steps.forEach(function(obj,index){
						 
						if(obj.class=='on'){
							self.type=obj.id
						} 
				      });

					 if(self.steps[0]){
					  //  self.steps[0].class='on';
						//self.type=self.steps[0].id;
					 }				 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },get_sign_list(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sign_list', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.sign_list=data.data;	 				 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },
		   get_template_content(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_template_content', {
					   token:self.token,
					   id:self.id
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					   self.content=data.data;	
					         setTimeout(function(){
								        self.current_length= data.data.length; 
								        self.count=Math.ceil(self.current_length/70);
					         },1000);	
				  } 
		      }).catch(function (error) {
			         
		      });
		   },get_template_sign(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_template_sign', {
					   token:self.token,
					   id:self.id
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					   self.signname=data.data;	
					   self.sign_selected=true
				  } 
		      }).catch(function (error) {
			         
		      });
		   },
		   get_template_value(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_template_value', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.list=data.data;	 				 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },
		   step(id){
		        var new_list=[];                   
				this.steps.forEach(function(obj,index){
					new_list[index]=obj;
					if( obj.id==id){
						new_list[index].class='on';
					}else{
					    new_list[index].class='';
					}
				});
			    this.steps=new_list;
				this.type=id;
		   },edit_template(){	        
		      let self=this;
			  self.$loading('提交中...');
		      axios.post(this.$api+'/message/edit_template', {
					   token:self.token,
					   type:self.type,
					   id:self.id,
					   content:self.content,
					   signname:self.signname
		      }).then(function (response) {  
			      self.$loading.close();
			      let data=response.data;
				  if(data.state==1){             
				             self.$toast.center('编辑成功，请等待审核');	
                             setTimeout(function(){
								        self.$loading.close();
										self.back();
					         },1000);				  
					 		 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  }else{
				     self.$loading.close();
				     self.$toast.center(data.msg);	
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		},watch:{
			   content(){
			     this.current_length=  this.$refs.count.value.length; 
			     this.count=Math.ceil(this.current_length/70);
			   }
              
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/edit_templete.vue